import Role from 'constants/role';
import { useHasRole } from 'hooks/useHasRole';
import React from 'react';
import { ReferenceField, TextField } from 'react-admin';
import VisibilityOffRounded from '@mui/icons-material/VisibilityOffRounded';
import { CopyField } from './CopyField';

function ChannelIdentifier({
  idField,
  titleField,
}) {
  return (
    <div style={{ display: 'inline-flex', gap: 5 }}>
      {idField && <CopyField source="id" label="ID" />}
      {titleField && <CopyField source="title" />}
    </div>
  );
}
function ChannelReferenceField({
  titleField,
  serviceField,
  translationTypeField,
  idField,
  ...props
}) {
  const hasRole = useHasRole();
  if (!hasRole(Role.CHANNEL_VIEW)) {
    return <VisibilityOffRounded />;
  }
  return (
    <ReferenceField reference="channels" {...props}>
      <ChannelIdentifier
        titleField={titleField}
        serviceField={serviceField}
        translationTypeField={translationTypeField}
        idField={idField}
      />
    </ReferenceField>
  );
}
ChannelReferenceField.defaultProps = {
  source: 'channelId',
  addLabel: true,
  label: 'Channel',
  idField: true,
  titleField: true,
  typeField: false,
};

export default ChannelReferenceField;
